export default __webpack_public_path__ + "static/media/confirm-icon.eab34763.svg";